import React from 'react';
import {Box} from '@mui/material';
import ChangePasswordForm from './ChangePasswordForm';
import {Formik} from 'formik';
import * as yup from 'yup';
import axios from 'axios';
import api from '@api';
import {toast} from 'react-toastify';
import {useAuthUser} from '@crema/utility/AuthHooks';

const validationSchema = yup.object({
  oldPassword: yup.string().required('No password provided.'),
  newPassword: yup.string().required('New password required.'),
  retypeNewPassword: yup
    .string()
    .oneOf([yup.ref('newPassword'), null], 'Passwords must match'),
});

const ChangePassword = ({ onSuccess } = {}) => {
  const {user} = useAuthUser();

  return (
    <Box sx={{position: 'relative'}}>
      <Formik
        validateOnChange={false}
        validateOnBlur={true}
        initialValues={{
          oldPassword: '',
          newPassword: '',
          retypeNewPassword: '',
        }}
        validationSchema={validationSchema}
        onSubmit={async (data, {setSubmitting, resetForm}) => {
          setSubmitting(true);
          try {
            const response = await axios.post(api.auth.updatePassword, {
              userId: user?.uid,
              userPassword: data.oldPassword,
              userNewPassword: data.newPassword,
            });
            if (response?.data?.status === 200) {
              toast.success('Password updated successfully');
              resetForm();
              onSuccess?.();
            } else {
              toast.error(response?.data?.message || 'Something went wrong');
            }
          } catch (error) {
            toast.error(error?.response?.data?.message || 'Something went wrong');
          } finally {
            setSubmitting(false);
          }
        }}
      >
        {() => <ChangePasswordForm onCancel={onSuccess} />}
      </Formik>
    </Box>
  );
};

export default ChangePassword;
